// index.js

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom';

// Polyfill de Event.path para navegadores que no lo exponen (Firefox/Safari).
// react-contextmenu@2.14 lee event.path en su rutina de cierre y truena con
// "e.path is undefined". composedPath() es el estandar equivalente.
if (typeof Event !== 'undefined' && !('path' in Event.prototype)) {
  Object.defineProperty(Event.prototype, 'path', {
    get: function () {
      return typeof this.composedPath === 'function' ? this.composedPath() : [];
    },
    configurable: true
  });
}

ReactDOM.render((
<Router>
    <App />
</Router>
), document.getElementById('root'));

serviceWorker.unregister();
//registerServiceWorker();
